import React from "react";
import { useP2PNavigation } from "../../../context/P2PNavigationContext";
import P2PAccessDeniedPage from "../../../pages/p2p/P2PAccessDeniedPage";

function P2PRouteGuard({ check, pageName, requiredRole, children }) {
  const { loading, ctx } = useP2PNavigation();
  if (loading) {
    return (
      <div className="container py-4">
        <div className="text-muted small">Checking access…</div>
      </div>
    );
  }
  if (!check(ctx)) {
    return <P2PAccessDeniedPage pageName={pageName} requiredRole={requiredRole} />;
  }
  return children;
}

export function RequireSuperAdmin({ children }) {
  return (
    <P2PRouteGuard
      pageName="P2P Platform Admin Management"
      requiredRole="Super Admin"
      check={(c) => !!c?.is_super_admin}
    >
      {children}
    </P2PRouteGuard>
  );
}

export function RequireP2PPlatformAdmin({ children }) {
  return (
    <P2PRouteGuard
      pageName="P2P Platform operations"
      requiredRole="P2P Platform Admin or Super Admin"
      check={(c) => !!c?.is_super_admin || !!c?.is_platform_admin}
    >
      {children}
    </P2PRouteGuard>
  );
}

export function RequireP2PTeamRole({ children }) {
  return (
    <P2PRouteGuard
      pageName="P2P Platform Admin Console"
      requiredRole="Procurement platform team (Head, Manager or Account Manager)"
      check={(c) =>
        !!c?.is_super_admin || !!c?.is_platform_admin || !!c?.is_platform_team
      }
    >
      {children}
    </P2PRouteGuard>
  );
}

export function RequireCompanyAdmin({ children }) {
  return (
    <P2PRouteGuard
      pageName="Company administration"
      requiredRole="Company Admin"
      check={(c) => !!c?.is_super_admin || !!c?.is_company_admin}
    >
      {children}
    </P2PRouteGuard>
  );
}

export function RequireCompanyMember({ children }) {
  return (
    <P2PRouteGuard
      pageName="Company P2P workspace"
      requiredRole="P2P organisation member"
      check={(c) => !!c?.has_p2p_org_membership}
    >
      {children}
    </P2PRouteGuard>
  );
}

export function RequireCommandCentreAccess({ children }) {
  return (
    <P2PRouteGuard
      pageName="Procurement Command Centre"
      requiredRole="Company Admin or authorised requester"
      check={(c) => !!c?.is_super_admin || !!c?.can_access_command_centre}
    >
      {children}
    </P2PRouteGuard>
  );
}

export function RequireServiceRequestAccess({ children }) {
  return (
    <P2PRouteGuard
      pageName="Procurement-as-a-Service"
      requiredRole="Authorised company requester"
      check={(c) => !!c?.is_super_admin || !!c?.can_submit_service_requests}
    >
      {children}
    </P2PRouteGuard>
  );
}

export function RequirePlatformServiceConsole({ children }) {
  return (
    <P2PRouteGuard
      pageName="P2P Platform service console"
      requiredRole="Platform Admin, platform head/manager, or account manager"
      check={(c) =>
        !!c?.is_super_admin ||
        !!c?.is_platform_admin ||
        !!c?.is_platform_team_console_admin ||
        !!c?.is_account_manager_only
      }
    >
      {children}
    </P2PRouteGuard>
  );
}

export function RequireCompanyApprover({ children }) {
  return (
    <P2PRouteGuard
      pageName="My approvals"
      requiredRole="Company approver"
      check={(c) =>
        !!c?.can_approve || !!c?.is_super_admin || !!c?.is_company_admin
      }
    >
      {children}
    </P2PRouteGuard>
  );
}

export function RequireCompanySalesApprover({ children }) {
  return (
    <P2PRouteGuard
      pageName="Sales & Auction Controls"
      requiredRole="Company Sales Approver or Company Admin"
      check={(c) => !!c?.can_access_sales_auction_controls}
    >
      {children}
    </P2PRouteGuard>
  );
}
